// extracted by mini-css-extract-plugin
export default {"description":"products_description__D2jTE","table_container":"products_table_container__dSnzH","image":"products_image__dikMp"};